/** Same rules as backend/utils/matchPredictionScoring.js */

export function pointsFor(predictedHome, predictedAway, actualHome, actualAway) {
  const ph = Number(predictedHome);
  const pa = Number(predictedAway);
  const ah = Number(actualHome);
  const aa = Number(actualAway);
  if ([ph, pa, ah, aa].some((n) => Number.isNaN(n))) return null;

  if (ph === ah && pa === aa) return 5;
  if (ph - pa === ah - aa && (ph > pa) === (ah > aa)) return 3;
  if (ph === pa && ah === aa) return 3;
  if ((ph > pa && ah > aa) || (ph < pa && ah < aa)) return 2;
  if (ph === ah || pa === aa) return 1;
  return 0;
}

/** Short reason for a finished pick. Matches the scoring guide. */
export function pointsReason(points) {
  const n = Number(points);
  if (!Number.isFinite(n)) return null;
  if (n >= 5) return "Exact score";
  if (n === 3) return "Right goal difference or draw";
  if (n === 2) return "Right result";
  if (n === 1) return "One team right";
  if (n === 0) return "No points";
  return null;
}

/** Points now, and if the home or away side scores one more. */
export function oneMoreGoal(predictedHome, predictedAway, homeScore, awayScore) {
  if (homeScore == null || awayScore == null) return null;
  if (predictedHome == null || predictedAway == null) return null;
  const now = pointsFor(predictedHome, predictedAway, homeScore, awayScore);
  if (now == null) return null;
  return {
    now,
    homeGoal: pointsFor(predictedHome, predictedAway, Number(homeScore) + 1, awayScore),
    awayGoal: pointsFor(predictedHome, predictedAway, homeScore, Number(awayScore) + 1),
  };
}
